"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SRAdvancedSettingData = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
// 占比变化数据
const getThresholdRatioItems = () => {
    return [
        { title: "0.25%", value: "0.0025", isHighlight: false },
        { title: "0.5%", value: "0.005", isHighlight: false },
        { title: "0.75%", value: "0.0075", isHighlight: false },
        { title: "1%", value: "0.01", isHighlight: false },
        { title: "2%", value: "0.02", isHighlight: false },
        { title: "3%", value: "0.03", isHighlight: false },
        { title: "4%", value: "0.04", isHighlight: false },
        { title: "5%", value: "0.05", isHighlight: false },
    ];
};
// 动量轮动周期、定时平衡数据
const getMomentumPeriodItems = ($st) => {
    const m15 = `15${$st("strateg_Min")}`;
    const hour1 = `1${$st("strateg_Hour")}`;
    const hour4 = `4${$st("strateg_Hour")}`;
    const hour6 = `6${$st("strateg_Hour")}`;
    const hour8 = `8${$st("strateg_Hour")}`;
    const hour12 = `12${$st("strateg_Hour")}`;
    const day1 = `1${$st("grid_order_lasting_day")}`;
    const day7 = `7${$st("grid_order_lasting_day")}`;
    return [
        { title: m15, value: "900", isHighlight: false },
        { title: hour1, value: "3600", isHighlight: false },
        { title: hour4, value: "14400", isHighlight: false },
        { title: hour6, value: "21600", isHighlight: false },
        { title: hour8, value: "28800", isHighlight: false },
        { title: hour12, value: "43200", isHighlight: false },
        { title: day1, value: "86400", isHighlight: false },
        { title: day7, value: "604800", isHighlight: false },
    ];
};
// 动量轮动周期、定时平衡展示数据，兼容老版本时间
const getMomentumPeriodDisplayItems = ($st) => {
    const m5 = `5${$st("strateg_Min")}`;
    return [{ title: m5, value: "300", isHighlight: false }, ...getMomentumPeriodItems($st)];
};
// 动量轮动收益率数据
const getMomentumThresholdRorItems = () => {
    return [
        { title: "1%", value: "0.01", isHighlight: false },
        { title: "3%", value: "0.03", isHighlight: false },
        { title: "5%", value: "0.05", isHighlight: false },
        { title: "10%", value: "0.1", isHighlight: false },
        { title: "15%", value: "0.15", isHighlight: false },
        { title: "20%", value: "0.2", isHighlight: false },
        { title: "25%", value: "0.25", isHighlight: false },
        { title: "30%", value: "0.3", isHighlight: false },
    ];
};
// 获取展示单条
const getSRAdvancedSettingSheetItemDisplay = (currentItemValue, items) => {
    return items.find((item) => new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value));
};
// 生成带高亮数据
const generateHighlightItems = (currentItemValue, items) => {
    return items.map((item) => {
        const isHighlight = new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value);
        item.isHighlight = isHighlight;
        return item;
    });
};
// 动量轮动收益率数据展示
const getSheetMomentumThresholdRorDisplay = (currentItemValue) => {
    if (currentItemValue === undefined) {
        return undefined;
    }
    return (getMomentumThresholdRorItems().find((item) => new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value)) || {
        title: trade_utils_lib_1.NumberCommonUtils.toPercent(Number(currentItemValue) * 100, false, true),
        value: `${currentItemValue}`,
        isHighlight: false,
    });
};
// 动量轮动收益率数据 生成带高亮数据
const generateHighlightMomentumThresholdRorItems = (currentItemValue) => {
    return getMomentumThresholdRorItems().map((item) => {
        const isHighlight = new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value);
        item.isHighlight = isHighlight;
        return item;
    });
};
// 动量轮动周期、定时平衡展示数据展示
const getSheetMomentumPeriodDisplay = (currentItemValue, $st) => {
    return getMomentumPeriodDisplayItems($st).find((item) => new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value));
};
// 动量轮动收益率数据 生成带高亮数据
const generateHighlightMomentumPeriodItems = (currentItemValue, $st) => {
    return getMomentumPeriodItems($st).map((item) => {
        const isHighlight = new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value);
        item.isHighlight = isHighlight;
        return item;
    });
};
// 占比变化数据展示
const getSheetThresholdRatioDisplay = (currentItemValue) => {
    if (currentItemValue === undefined) {
        return undefined;
    }
    return (getThresholdRatioItems().find((item) => new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value)) || {
        title: trade_utils_lib_1.NumberCommonUtils.toPercent(Number(currentItemValue) * 100, false, true),
        value: `${currentItemValue}`,
        isHighlight: false,
    });
};
// 占比变化数据 生成带高亮数据
const generateHighlightThresholdRatioItems = (currentItemValue) => {
    return getThresholdRatioItems().map((item) => {
        const isHighlight = new trade_utils_lib_1.SafeDecimal(currentItemValue).equals(item.value);
        item.isHighlight = isHighlight;
        return item;
    });
};
exports.SRAdvancedSettingData = {
    getThresholdRatioItems,
    getMomentumPeriodItems,
    getMomentumPeriodDisplayItems,
    getMomentumThresholdRorItems,
    getSRAdvancedSettingSheetItemDisplay,
    generateHighlightItems,
    getSheetMomentumThresholdRorDisplay,
    generateHighlightMomentumThresholdRorItems,
    getSheetMomentumPeriodDisplay,
    generateHighlightMomentumPeriodItems,
    getSheetThresholdRatioDisplay,
    generateHighlightThresholdRatioItems,
};
